const PRODUCT_HOSTS = new Set([
  "chat.legalpal.app",
  "sign.legalpal.app",
  "app.legalpal.app",
  "account.legalpal.app",
  "client.legalpal.app",
]);

export function isProductHost(hostname = window.location.hostname): boolean {
  return PRODUCT_HOSTS.has(hostname);
}

export function goTo(url: string): void {
  if (isProductHost()) window.location.href = url;
  else window.parent.location.href = url;
}

export function shellUrl(path: string): string {
  if (path === "home" || path === "" || path === "/") return "https://legalpal.app/";
  if (path === "privacy" || path === "privacy-policy") return "https://legalpal.app/privacy-policy";
  if (isProductHost()) {
    if (path === "sign") return "https://sign.legalpal.app";
    if (path === "chat") return "https://chat.legalpal.app";
    if (path === "app") return "https://app.legalpal.app";
    if (path === "account") return "https://account.legalpal.app";
    if (path === "client") return "https://client.legalpal.app";
  }
  return `https://legalpal.app/${path}`;
}

export function authState(): string {
  if (!isProductHost()) return "";
  const json = JSON.stringify({ r: `https://${window.location.hostname}` });
  return btoa(json).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/g, "");
}
